import Accordion from 'accordion-js';

function accordion() {
    new Accordion('.accordion');
}

export default accordion;